import createListBundle from '~/src/Lib/createListBundle'
import { Item as schema } from '~/src/Store/Schemas'

export const initialState = {
  search: '',
  ordering: ['name', 'asc'],
}

export default createListBundle({
  entityName: 'item',
  initialState,
  schema,
  fetchHandler: ({ apiFetch, params }) => apiFetch('/items/', { ...params, pagination: 0 }),
  flags: { keys: ['METRC'] }
})
